import React, { useMemo, useState } from 'react';
import Accordion from "../../components/accordion";
import { useGroupChatContext } from '../../context/groupchatContext';
import { useGetPatientInfoQuery } from '../../services/chatService';
import PatientAppointment from "../appointment/patientAppointment";
import PatientAllergy from './allergy';
import PatientMedication from './medication';
import icVezo from '../../assets/ic-doc/vezo.svg'
import VezoSessions from '../vezosession';
import ActionMenuList from '../../components/ActionMenuList';
import { PlusIcon, CalendarDaysIcon } from '@heroicons/react/20/solid';
import MainPageDialog from '../../components/dialog';
import ScheduleSessionForm from '../vezosession/scheduleSession';
import { useGetVezoRoomsQuery } from '../../services/vezoService';
import { CreateRoomDialog } from '../vezosession/createRoomPopup';
import { InstantSessionDialog } from '../vezosession/instantSessionPopup';
import EncounterList from '../encounter/encounterList';
import { IoIosInformationCircle } from "react-icons/io";
import Tooltip from '../../components/Tooltip';
import { useGenerateQrcodeQuery } from '../../services/procedureService';
import { useSelector, shallowEqual } from "react-redux";
import { OptimalCarePracticeID } from '../../utils/constant';
const PatientInfo = React.memo(({ }) => {
    const {
        practice: { id: practice_id, is_nursing: isNursingPractice },
        auth: authToken,
    } = JSON.parse(localStorage.getItem("auth"));

    const groupChatContext = useGroupChatContext();
    const [isOpenVezoPopup, setIsOpenVezoPopup] = useState(false)
    const [isOpenScheduledSessionPopup, setIsOpenScheduledSessionPopup] = useState(false);
    const [isOpenInstantSessionPopup, setIsOpenInstantSessionPopup] = useState(false)
    const [openRoomPopup, setOpenRoomPopup] = useState({ isOpen: false })


    const { selectedChat, authData, setIsOpenPatientMedsAllergyPopup, setIsOpenRequestAppointmentPopup, setIsOpenPatientApptPopup } = useMemo(() => ({
        selectedChat: groupChatContext.selectedChat,
        authData: groupChatContext.authData,
        setIsOpenPatientMedsAllergyPopup: groupChatContext.setIsOpenPatientMedsAllergyPopup,
        setIsOpenRequestAppointmentPopup: groupChatContext.setIsOpenRequestAppointmentPopup,
        setIsOpenPatientApptPopup: groupChatContext.setIsOpenPatientApptPopup,
    }));

    const { data } = useGetPatientInfoQuery({ pid: selectedChat.pid });
    const { data: vezoAllRooms } = useGetVezoRoomsQuery(null, { skip: !authData?.is_provider });
    // Generate QR code for vezo session
    const { data: qrCodeData } = useGenerateQrcodeQuery({ pid: selectedChat.pid }, { skip: !selectedChat.pid});
    const initSession = (callFrom) => {
        if (!vezoAllRooms?.length) {
            const openFormFun = () => {
                callFrom == 'scheduled_session' ? setIsOpenScheduledSessionPopup(true) : setIsOpenInstantSessionPopup(true)
            }
            setOpenRoomPopup({ isOpen: true, callBackFun: openFormFun })
        }
        else {
            if (callFrom == 'scheduled_session') {
                setIsOpenScheduledSessionPopup(true)
            }
            else if (callFrom == 'instant_session') {
                setIsOpenInstantSessionPopup(true)
            }
        }
    }

    const onCloseVezoRoom = (from) => {
        if (from == 'submit') {
            openRoomPopup.callBackFun()
        }
        setOpenRoomPopup({ isOpen: false })
    }

    return (
        <div className='flex flex-col space-y-2'>
            {qrCodeData && qrCodeData?.response?.data && <div className="p-2 bg-gray rounded-2xl  text-center">
                <div className="border border-gray-300 p-1 rounded-lg inline-block bg-gray-50">
                    <img
                        src={`data:image/png;base64,${qrCodeData?.response?.data}`}
                        alt="QR Code"
                        className="w-24 h-24 object-contain"
                    />
                </div>
            </div>}
            <div className='flex justify-between items-center p-2 bg-gray-100'>
                <div className='flex items-center gap-7'>
                    {authData?.is_provider ?
                        <ActionMenuList
                            icon={<Tooltip content="Schedule or Start vezo session" position="right">
                                <PlusIcon className="h-6 w-6 text-gray-400 cursor-pointer" />
                            </Tooltip>
                            }
                            title=""
                            menuItemStyle="left-0"
                            size="xs"
                            menuList={[
                                {
                                    label: "Schedule Session",
                                    onClick: () => initSession('scheduled_session'),
                                },
                                {
                                    label: "Instant Session",
                                    onClick: () => initSession('instant_session')
                                },
                            ]}
                        />
                        : <span className='w-[31px]'>&nbsp;</span>}
                    <h2 className='text-lg font-medium'>vezo Sessions</h2>
                </div>
                <Tooltip content="vezo Sessions" position="left">
                    <img src={icVezo} onClick={() => setIsOpenVezoPopup(!isOpenVezoPopup)} className="h-8 w-8 rounded-lg cursor-pointer" alt="" />
                </Tooltip>
            </div>
            <Accordion
                title='Appointments'
                open={true} showDialogue={true}
                leftDialogHandler={() => setIsOpenRequestAppointmentPopup(true)}
                rightDialogHandler={() => setIsOpenPatientApptPopup(true)}
                icon={<CalendarDaysIcon className="h-5 w-5 text-gray-400 cursor-pointer" />}
                leftIcon={practice_id !== OptimalCarePracticeID ?
                    <div className=' px-[2px] bg-white border border-gray-d2 rounded flex items-center justify-center'>
                        <PlusIcon className="h-6 w-6 text-gray-400 cursor-pointer" /></div> : null}
                leftIconTooltip={authData?.is_provider ? "Schedule Appointment" : "Request Appointmentsss"}
                iconTooltip="Future Appointments"
            >
                <PatientAppointment practiceId={practice_id} isNursingPractice={isNursingPractice} />
            </Accordion>
            <PatientMedication medications={data?.medications} showDetails={false} showDialogue={true} rightDialogHandler={() => { setIsOpenPatientMedsAllergyPopup(true) }} />
            <PatientAllergy allergies={data?.allergies} showDetails={false} showDialogue={true} rightDialogHandler={() => { setIsOpenPatientMedsAllergyPopup(true) }} />
            {/* <Accordion title='Encounters' open={true}>
                <EncounterList />
            </Accordion> */}

            {isOpenVezoPopup ?
                <VezoSessions
                    closeHandler={() => setIsOpenVezoPopup(false)}
                />
                : null
            }

            {isOpenScheduledSessionPopup ?
                <MainPageDialog
                    title="Schedule Session"
                    onCancelHandler={() => setIsOpenScheduledSessionPopup(false)}
                    modalSize="large"
                    maxHeight={true}
                    customHeight={"max-h-[80vh]"}
                    component={
                        <ScheduleSessionForm closeSessionPopup={() => setIsOpenScheduledSessionPopup(false)} />
                    }
                    footer={false}
                >
                </MainPageDialog>
                : null
            }

            {openRoomPopup?.isOpen ? <CreateRoomDialog closeHandler={onCloseVezoRoom} /> : null}
            {isOpenInstantSessionPopup ? <InstantSessionDialog closeHandler={() => setIsOpenInstantSessionPopup(false)} /> : null}
        </div>
    )
})

export default PatientInfo;